if(document.querySelector("#collectionSort")) {
  document.querySelector("#collectionSort").addEventListener("change", function(e) {
    var hdl = this.value;

    console.log(document.querySelector("input[name='sort_by'][data-sort='" + hdl + "']"));
    var radio = document.querySelector("input[name='sort_by'][data-sort='" + hdl + "']");
    radio.checked = true;

    radio.click();

    document.dispatchEvent(new Event('filter_updated'));
  });
}

window.addEventListener("click", function(e) {
  if(e.target.closest(".wishlist-hero-list-card-footer-delete") || e.target.classList.contains(".wishlist-hero-list-card-footer-delete")) {
    return;
  }
  
  if(e.target.closest(".wishlist-hero-list-card")) {
  	e.preventDefault();
    // commented by developer to open wishlist product in same window
    //window.open(e.target.closest(".wishlist-hero-list-card").querySelector(".MuiLink-root").getAttribute("href"), '_blank');
    window.open(e.target.closest(".wishlist-hero-list-card").querySelector(".MuiLink-root").getAttribute("href"), '_self');
  }
});

function getFilterCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var delete_cookie = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

window.onload = (event) => {
    if(getFilterCookie("sizeFilter")){
      document.querySelector('[data-group="Size"]').querySelector('ul').style.display = getFilterCookie("sizeFilter"); 
    }
    if(getFilterCookie("priceFilter")){
      document.querySelector('[data-group="Price"]').querySelector('.filter-drawer__price-range').style.display = getFilterCookie("priceFilter"); 
    }
    if(getFilterCookie("colorFilter")){
      document.querySelector('[data-group="Color"]').querySelector('ul').style.display = getFilterCookie("colorFilter");
    }
    if(getFilterCookie("brandFilter")){
      document.querySelector('[data-group="Brand"]').querySelector('ul').style.display = getFilterCookie("brandFilter");
    }
    if(getFilterCookie("heelheightFilter")){
      document.querySelector('[data-group="Heel Height"]').querySelector('ul').style.display = getFilterCookie("heelheightFilter");
    }
    if(getFilterCookie("widhtFilter")){
      document.querySelector('[data-group="Width"]').querySelector('ul').style.display = getFilterCookie("widhtFilter");
    }

    // delete filter cookes arfer reseting
    delete_cookie("sizeFilter");
    delete_cookie("priceFilter");
    delete_cookie("colorFilter");
    delete_cookie("brandFilter");
    delete_cookie("heelheightFilter");
    delete_cookie("widhtFilter");
};